// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompanyDnaChangedByModel () {
        return CompanyDnaChangedByModel;
    },
    get CompanyDnaModel () {
        return CompanyDnaModel;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const CompanyDnaChangedByModel = _zod.z.object({
    type: _zod.z.enum([
        "user",
        "automation"
    ]),
    email: _zod.z.string().nullable(),
    name: _zod.z.string().nullable()
});
const CompanyDnaModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    company_id: _utilsisomorphic.transformObjectId,
    content: _zod.z.string(),
    source: _zod.z.enum([
        "manual",
        "exa"
    ]),
    changed_by: CompanyDnaChangedByModel,
    reason: _zod.z.string(),
    created_at: _utilsisomorphic.transformDate,
    metadata: _zod.z.object({
        sources: _zod.z.array(_zod.z.string()).optional()
    }).optional()
});
